const Estimate = () => {
  return <>Estimates Page</>;
};

export default Estimate;
